<template>
    <div class="header">
        <b-navbar toggleable="lg" type="light" variant="info" style="background-color:#FFFFFF !important">
            <div class="container px-lg-5">
                <b-navbar-brand>
                    <router-link to="/">
                        <img src="../assets/img/logo/logo.svg" class="logo-img" alt="logo">
                    </router-link>
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="navbar-nav ms-auto mb-2 mb-lg-0">
                        <b-nav-item> <router-link class="nav-link" to="/about-us">About us</router-link></b-nav-item>
                        <b-nav-item><router-link class="nav-link" to="/faq">Faq</router-link> </b-nav-item>   
                                    
                    </b-navbar-nav>
                </b-collapse>
            </div>
        </b-navbar>
        <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light" style="background-color:#FFFFFF !important">
            <div class="container px-lg-5">
                <a class="navbar-brand" href="#">
                    <img src="../assets/img/logo/plus-minus-logo.svg" class="logo-img" alt="logo">
                </a>
                <button class="navbar-toggler collapsed border-0" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                    <div class="close-icon py-1">
                        <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.133789" y="26.5338" width="39.2289" height="4" rx="2" transform="rotate(-41.8667 0.133789 26.5338)" fill="black"/>
                            <rect x="29.1956" y="29.6495" width="39.2289" height="4" rx="2" transform="rotate(-137.539 29.1956 29.6495)" fill="black"/>
                        </svg>       
                    </div>
                    
                </button>


                
            
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li class="nav-item"><a class="nav-link " aria-current="page" href="#!">About us</a></li>
                        <li class="nav-item"><a class="nav-link " aria-current="page" href="/faq">Faq</a></li>
                    </ul>
                </div>
            </div>
        </nav> -->
    </div>
</template>

<script>
    export default {
        name:'HeaderAgency',
        data (){
            return {
                load: false,
                limitPosition: 200,
                scrolled: false,
                lastPosition: 500,
            }
        },
        mounted (){
            (function() {
                scrollTo();
            })();

            function scrollTo() {
                const links = document.querySelectorAll('.scroll > a');
                links.forEach(each => (each.onclick = scrollAnchors));
            }

            function scrollAnchors(e, respond = null) {
                const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
                e.preventDefault();
                var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
                const targetAnchor = document.querySelector(targetID);
                if (!targetAnchor) return;
                const originalTop = distanceToTop(targetAnchor);
                window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
                const checkIfDone = setInterval(function() {
                    const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 190;
                    if (distanceToTop(targetAnchor) === 0 || atBottom) {
                        targetAnchor.tabIndex = '-1';
                        targetAnchor.focus();
                        clearInterval(checkIfDone);
                    }
                }, 800);
            }
        },
        methods: {
            // sticky menu script
            handleScroll() {
                if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
                    this.scrolled = true;
                    // move up!
                } 
                if (this.lastPosition > window.scrollY) {
                    this.scrolled = true;
                    // move down
                }
                this.lastPosition = window.scrollY;
                this.scrolled = window.scrollY > 50;
            },

            // offcanvas searchbox
            // toggleClass(addRemoveClass, className) {
            //     const el = document.querySelector('#search-overlay');
            //     if (addRemoveClass === 'addClass') {
            //         el.classList.add(className);
            //     } else {
            //         el.classList.remove(className);
            //     }
            // },
        }, 
        created() {
            window.addEventListener("scroll", this.handleScroll);
        },
        destroyed() {
            window.removeEventListener("scroll", this.handleScroll);
        },
    }
</script>

<style lang="scss" scoped>
    .header-agency {
        &.is-sticky {
            top: 0;
            left: 0;
            position: fixed;
            width: 100%;
        }
    }
    .navbar {
        padding: 0.5rem 0;
    }
</style>